import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: 'Paweł Siwirski',
    role: 'Prokurent, LOG-IT',
    image: 'assets/images/speakers/1.png',
    text: '„MTC Events poprowadziło dla nas cykl śniadań biznesowych, których celem było dotarcie do decydentów z wybranych branż. Dzięki dobrze dobranej formule i sprawnej organizacji udało się nawiązać realne rozmowy z potencjalnymi partnerami i klientami. Zdecydowanie warto było zainwestować czas i budżet, każdy ze zrealizowanych eventów wnosił realną wartość i dawał przestrzeń do rozmów, które przekładały się na konkrety.”'
  },
  {
    name: 'Sędzia dr Piotr Stanisławiszyn',
    role: 'Przewodniczący Sekcji INSO Instytut Allerhanda',
    image: 'assets/images/speakers/2.png',
    text: '„INSO 2024 okazało się rekordową edycją, w wydarzeniu wzięło udział ponad 350 uczestników, a poziom merytoryczny i organizacyjny został bardzo wysoko oceniony przez środowisko. Współpraca z MTC Events przebiegała sprawnie i z pełnym profesjonalizmem, każdy element konferencji był dopięty, a my mogliśmy skupić się na treści i gościach.”'
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    swipe: false,
    draggable: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 992, // tablets and smaller
        settings: {
          slidesToShow: 1,
          swipe: false,
          draggable: false,
        }
      }
    ]
  };

  return (
    <div className="slider testimonial-slide px-2 px-md-5">
      <Slider {...settings}>
        {testimonials.map((item, index) => (
          <div key={index} className="px-2">
            <div className="box1 p-4 rounded bg-white w-100 h-100 d-flex flex-column justify-content-between">
              <div className="testimonial-content position-relative">
                <i className="fa fa-quote-left position-absolute p-5" aria-hidden="true"></i>
                <p className="my-4 position-relative p-3">{item.text}</p>
              </div>
              <div className="testimonial-bio d-flex align-items-center">
                <img
                  src={item.image}
                  alt={item.name}
                  className="bio-img me-3 rounded-circle"
                  width={60}
                />
                <div>
                  <p className="mb-1 fw-semibold black">{item.name}</p>
                  <p>{item.role}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;
